import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ResidentialPage = lazy(() => import('../pages/residential/page'));
const CommercialPage = lazy(() => import('../pages/commercial/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ProjectsPage = lazy(() => import('../pages/projects/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const ClosedCellSprayFoamPage = lazy(() => import('../pages/closed-cell-spray-foam/page'));
const OpenCellSprayFoamPage = lazy(() => import('../pages/open-cell-spray-foam/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about-yuma-insulation',
    element: <AboutPage />,
  },
  {
    path: '/residential-insulation-yuma',
    element: <ResidentialPage />,
  },
  {
    path: '/commercial-insulation-yuma',
    element: <CommercialPage />,
  },
  {
    path: '/insulation-services-arizona',
    element: <ServicesPage />,
  },
  {
    path: '/yuma-projects',
    element: <ProjectsPage />,
  },
  {
    path: '/yuma-insulation-faq',
    element: <FAQPage />,
  },
  {
    path: '/closed-cell-spray-foam-yuma',
    element: <ClosedCellSprayFoamPage />,
  },
  {
    path: '/open-cell-spray-foam-yuma',
    element: <OpenCellSprayFoamPage />,
  },
  // Redirects from old URLs to new URLs
  {
    path: '/insulation-faq',
    element: <Navigate to="/yuma-insulation-faq" replace />,
  },
  {
    path: '/closed-cell-spray-foam',
    element: <Navigate to="/closed-cell-spray-foam-yuma" replace />,
  },
  {
    path: '/open-cell-spray-foam',
    element: <Navigate to="/open-cell-spray-foam-yuma" replace />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
